import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilteredKeyValueRequestDTO } from '../Common/ValueListService/valuelist.interface';
import { ValueListService } from '../Common/ValueListService/value-list.service';
import { UnsubscribedAlertsCreateRequestDTO } from './unsubscribe-email.interface';
import { UserLoginService } from '../Common/UserLoginService/userlogin.service';
import { UnsubscribeEmailService } from './unsubscribe-email.service';

@Component({
  selector: 'app-unsubscribe-email',
  templateUrl: './unsubscribe-email.component.html',
  styleUrls: ['./unsubscribe-email.component.css']
})
export class UnsubscribeEmailComponent {
  unsubscribeForm: FormGroup;
  valuelistService = inject(ValueListService)
  unsubscribeEmailService = inject(UnsubscribeEmailService)
  User = inject(UserLoginService).User()
  message: string = '';
  selectedCompanyId = 0;
  submitting: boolean = false
  constructor(private fb: FormBuilder) {
    this.unsubscribeForm = this.fb.group({
      email: ['', [Validators.required]]
    });
  }

  get email() {
    return this.unsubscribeForm.get('email');
  }

  ngOnInit(): void {
    let urlArray = window.location.href.toLocaleLowerCase()
    if (urlArray.includes('companyid=')) {
      this.selectedCompanyId = +urlArray.split('=')[1]
    } else {
      const host = window.location.host;
      if (host.includes('localhost')) {
        this.selectedCompanyId = 1;
      } else {

        const data: FilteredKeyValueRequestDTO = {
          dCode: 'HostCompanyId',
          tenantId: 1,
          tenantBranchId: 1,
          FilterValue: host
        };
        this.valuelistService.ValueListItem_GetFilteredKeyValueDictionaryByCode(data).subscribe(res => {
          if (res.items.length > 0) {
            this.selectedCompanyId = +res.items[0]?.key;
          }
        });
      }
    }
  }
  onSubmit() {
    if (this.unsubscribeForm.valid) {
      this.submitting = true
      const emailValue = this.unsubscribeForm.value.email;

      let createDTO: UnsubscribedAlertsCreateRequestDTO = {
        tenantId: this.selectedCompanyId,
        tenantBranchId: 1,
        vendorCompany: '',
        emailId: emailValue,
        otherDetail1: '',
        otherDetail2: '',
        otherDetail3: '',
        otherDetail4: '',
        otherDetail5: '',
        otherDetail6: '',
        actionUser: this.User?.userId?.toString() ?? '0'
      }
      this.unsubscribeEmailService.UnSubscribeAlerts_Create(createDTO).subscribe({
        next: (res) => {
          this.message = `You have been unsubscribed successfully`;
          this.submitting = false
          this.unsubscribeForm.reset();
        }, error: () => {
          this.submitting = false

        }
      }
      )

    }
  }
}